// Copiar texto para a área de transferência (VD) — com verdade sobre o resultado.
//
// `navigator.clipboard.writeText` exige contexto seguro (https ou localhost) e
// gesto do usuário; em http de rede local o objeto nem existe, e em alguns
// navegadores a promessa rejeita sem mensagem útil. O que este módulo garante é
// que a tela SABE se copiou ou não — e mostra o texto selecionável quando não.
//
// Padrão já usado em `SecaoCaptacao` e `DialogoRedefinirSenha`; aqui extraído
// para os dois botões de relatório não repetirem o try/catch.

/**
 * @returns {Promise<boolean>} true se copiou de verdade.
 */
export async function copiarTexto(texto, clipboard = globalThis.navigator?.clipboard) {
  if (!clipboard || typeof clipboard.writeText !== 'function') return false;
  try {
    await clipboard.writeText(String(texto ?? ''));
    return true;
  } catch {
    return false;
  }
}
